<template>

  <div class="uk-width-1-1 area-riservata__filters" :class="view === 'desktop' ? ' uk-visible@l' : ''">

    <div v-if="view === 'desktop'" class="area-riservata__button-back uk-visible@l">
      <a :href="listUrl" class="">
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve" class="icon-white"><polygon id="Fill-1" points="7.1,0 8.1,1 4.1,5 8.1,9 7.1,10 3.1,6 2.1,5 3.1,4 "></polygon></svg>
        </span>
        {{ $t('frontend-mtg.area_riservata.ordini.torna_elenco') }}
      </a>
    </div>
    <div v-if="view === 'desktop'" class="uk-hidden@desktop">
      <div class="area-riservata__filters--main-title">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 18.6 18.6" style="enable-background:new 0 0 18.6 18.6;" xml:space="preserve" class="">
          <path id="Shape" class="st0" d="M3.5,10.7V1 M3.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M3.5,10.7c-0.8,0-1.5,0.7-1.5,1.5  s0.7,1.5,1.5,1.5 M3.5,17.5v-3.7 M15.5,10.7V1 M15.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M15.5,10.7  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 M15.5,17.5v-3.7 M9.5,4.7V1 M9.5,4.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M9.5,4.7  C8.7,4.7,8,5.4,8,6.2s0.7,1.5,1.5,1.5 M9.5,17.5V7.7"></path>
        </svg>
        {{ $t('frontend-mtg.area_riservata.ordini.ordina_per') }}
      </div>


      <order-items-sorting v-if="view === 'desktop'"></order-items-sorting>

    </div>

    <div class="area-riservata__filters--main-title">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 18.6 18.6" style="enable-background:new 0 0 18.6 18.6;" xml:space="preserve" class="">
        <path id="Shape" class="st0" style="fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;" d="M3.5,10.7V1 M3.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M3.5,10.7c-0.8,0-1.5,0.7-1.5,1.5  s0.7,1.5,1.5,1.5 M3.5,17.5v-3.7 M15.5,10.7V1 M15.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M15.5,10.7  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 M15.5,17.5v-3.7 M9.5,4.7V1 M9.5,4.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M9.5,4.7  C8.7,4.7,8,5.4,8,6.2s0.7,1.5,1.5,1.5 M9.5,17.5V7.7"></path>
      </svg>
      {{ $t('frontend-mtg.area_riservata.ordini.filtra_per') }}
    </div>
    <div v-if="hasFilters" class="filters__nav-cta">
      <a :href="pageUrl" :title="$t('frontend-mtg.area_riservata.ordini.resetta_filtri')" class="filters__nav-cta toggle">{{ $t('frontend-mtg.area_riservata.ordini.resetta_filtri') }}</a>
    </div>
    <ul uk-accordion class="accordion uk-accordion">
      <!--<li v-if="filterCodes" class="uk-position-relative uk-open">-->
      <!--  <a href="#" class="uk-accordion-title area-riservata__filters&#45;&#45;title">{{ $t('frontend-mtg.area_riservata.ordini.code') }}</a>-->
      <!--  <div class="uk-accordion-content">-->
      <!--    <form class="uk-form">-->
      <!--      <select class="uk-select" id="form-stacked-select" v-model="selectedCode" @change="setFilter('code')">-->
      <!--        <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select') }}</option>-->
      <!--        <option v-for="filterCode in filterCodes" :value="filterCode">{{ filterCode }}</option>-->
      <!--      </select>-->
      <!--    </form>-->
      <!--  </div>-->
      <!--</li>-->
      <li v-if="filterCodeProducts" class="uk-position-relative uk-open">
        <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.code_product') }}</a>
        <div class="uk-accordion-content">
          <form class="uk-form">
            <select class="uk-select" id="form-stacked-select" v-model="selectedCodeProduct" @change="setFilter('code_product')">
              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>
              <option v-for="filterCodeProduct in filterCodeProducts" :value="filterCodeProduct">{{ filterCodeProduct }}</option>
            </select>
          </form>
        </div>
      </li>
<!-- <li v-if="filterCodeInternals" class="uk-position-relative uk-open">-->
<!--        <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.code_internal') }}</a>-->
<!--        <div class="uk-accordion-content">-->
<!--          <form class="uk-form">-->
<!--            <select class="uk-select" id="form-stacked-select" v-model="selectedCodeInternal" @change="setFilter('code_internal')">-->
<!--              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>-->
<!--              <option v-for="filterCodeInternal in filterCodeInternals" :value="filterCodeInternal">{{ filterCodeInternal }}</option>-->
<!--            </select>-->
<!--         </form>-->
<!--       </div>-->
<!--      </li>-->

      <li class="uk-position-relative uk-open">
       <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.shipment_status') }}</a>
        <div class="uk-accordion-content">
          <form class="uk-form">
            <select class="uk-select" id="form-stacked-select" v-model="selectedShipmentStatus" @change="setFilter('shipment_status')">
              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>
              <option value="1">{{ $t('frontend-mtg.area_riservata.ordini.processing') }}</option>
              <option value="2">{{ $t('frontend-mtg.area_riservata.ordini.partially_shipped') }}</option>
              <option value="3">{{ $t('frontend-mtg.area_riservata.ordini.shipment_completed') }}</option>
            </select>
          </form>
        </div>
      </li>
<!--      <li class="uk-position-relative uk-open_">-->
<!--        <a href="#" class="uk-accordion-title area-riservata__filters&#45;&#45;title">Data prevista spedizione</a>-->
<!--        <div class="uk-accordion-content" >-->
<!--          <form class="uk-form datepicker">-->
<!--            <input type="text" data-uk-datepicker="{format:'DD.MM.YYYY'}">-->
<!--          </form>-->
<!--        </div>-->
<!--      </li>-->

    </ul>
  </div>

</template>
<script>
export default {
  props: {
    filtersList: {
      type: [Array, Object],
      required: true,
    },
    pageUrl: {
      type: String,
      required: true,
    },
    listUrl: {
      type: String,
      required: true,
    },
    view: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      count: 0,
      selectedCodeProduct: null,
      selectedCodeInternal: null,
      selectedShipmentStatus: null,
      selectedCode: null,
      filterCodeProducts: null,
      filterCodeInternals: null,
      filterShipmentStatus: null,
      filterCodes: null,
    }
  },
  computed: {
    filters(){
      return this.$store.state.grid.filters;
    },
    hasFilters(){
      return Object.keys(this.$store.state.grid.filters).filter(key => key !== 'order_id').length > 0;
    },
  },
  mounted() {
    this.filterCodeProducts = this.filtersList['code_product']
    this.filterCodeInternals = this.filtersList['code_internal']
    this.filterCodes = this.filtersList['code']
  },
  methods: {
    setFilter(type, value = null) {
     let column = null;
     switch (type) {
       case 'code_product':
         column = type
         value = this.selectedCodeProduct
         break;
       case 'code_internal':
         column = type
         value = this.selectedCodeInternal
         break;
       case 'code':
         column = type
         value = this.selectedCode
         break;
       case 'shipment_status':
         column = type
         value = this.selectedShipmentStatus
         break;
       default:
         return;
     }
     this.removeFilter(type)
     this.$store.commit('grid/addFilter', {
       column: type,
       value: value
     });
    },
    removeFilter(type, value){
      this.$store.commit('grid/removeFilter', {
        column: type,
      });
      if (! this.$store.state.grid.filters[type] && this.$store.state.grid.filters.hasOwnProperty(type)) {
        delete this.$store.state.grid.filters[type];
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrderItemsFilters.vue